import { useState, FC, createContext } from "react";
import { ToastContextType, ToastObject, Props } from "src/types/index";

export const ToastContext = createContext<ToastContextType | null>(null);

const ToastProvider: FC<Props> = ({ children }) => {
  const [toast, setToast] = useState<Array<ToastObject>>([]);

  const setToastMessage = (toast: ToastObject) => {
    setToast((prevState) => [...prevState, toast]);
  };

  const deleteToast = (id: number) => {
    setToast((prevState) => prevState.filter((toast) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={{ toast, setToastMessage, deleteToast }}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
